import { render, staticRenderFns } from "./layout-database.vue?vue&type=template&id=e019af66&"
import script from "./layout-database.vue?vue&type=script&lang=js&"
export * from "./layout-database.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports